import React from "react";
import { withRouter } from "react-router-dom";

import { Container } from "react-grid-system";
import api from "../../services/api";
import downloadFile from "../../utils/downloadFile";
import GenericUpper from "../../components/generic-upper";
import Button from "../../components/button/button_v2";
import TableWithLabelBlackV2 from "../../components/TableWithLabelBlack/indexV2";
import { Auxiliar, BodyM, BodyP, TaglineG, TaglineM, TaglineP } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";
import ModalExportar from "../../components/modal/modalArtExportar";
import ModalYesNo from "../../components/modal/modalYesNo";
import Modal from "../../components/modal/modalGeneric";
import { ArtsAddContainer } from "./styles";
import { store } from "react-notifications-component";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";

import CardGeral from "../../components/card-geral/index";


export const USER = "@userinfo";


class EditContracts extends React.Component {
    state = {
        id: "",
        loading: false,
        hideButton: false,
        limit: 5,
        offSet: 0,
        newOffSet: "",
        contracts: [],
        addModalShow: false,
        showModalText: false,
        size_screen: window.screen.width,
        estado: '',
        ordemInicial: '',
        ordemFinal: '',
        numeroOrdemMin: null,
        numeroOrdemMax: null,
        textModalYesNo: '',
        loadingExport: false,
        showModalAlert: false,
    };



    componentDidMount() {
        setInterval(async()=>{
            this.setState({size_screen: window.screen.width});
        }, 990);
        this.getArtState();
        this.getContracts();
        this.loadOrder();
    };

    getContracts = async () => {
        const id = this.props.match.params.id;
        this.setState({ id });
        const { limit } = this.state;
        try {
            const response = await api.get(`/arts/${id}/contratos?limit=` + limit);
            const contracts = response.data.data;
            const { numero_ordem_min, numero_ordem_max } = response.data;
            this.setState({
                contracts,
                numeroOrdemMin: numero_ordem_min ?? null,
                numeroOrdemMax: numero_ordem_max ?? null,
                loading: false,
                hideButton: false,
            });

        } catch (err) {
            this.setState({ loading: false, hideButton: true });
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    err,
                    "ERRO-631 Erro ao carregar os contratos da ART/TRT - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }

    };

    getArtState = async () => {
        try {
            const id = this.props.match.params.id;
            const response = await api.get(`/arts/${id}`);
            this.setState({ estado: response.data.data.agro_creas.estado });
            
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-632 Erro ao carregar os dados da ART/TRT - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
        
    };

    redirect = () => {
        this.props.history.push(`/newcontract/${this.props.match.params.id}`);
    };

    formatData = (data) => {
        const dateOnly = data.split('T')[0];
        const [year, month, day] = dateOnly.split('-');
        
        const localDate = new Date(year, month - 1, day);
        
        let dayFormatted = localDate.getDate();
        if (dayFormatted <= 9) {
            dayFormatted = "0" + dayFormatted;
        }
        
        let monthFormatted = localDate.getMonth() + 1;
        if (monthFormatted <= 9) {
            monthFormatted = "0" + monthFormatted;
        }
        
        const yearFormatted = localDate.getFullYear();
        
        return dayFormatted + "/" + monthFormatted + "/" + yearFormatted;
    };

    loadMore = async () => {
        const id = this.props.match.params.id;
        this.setState({ id });
        this.setState({ loading: true, hideButton: true });
        const { limit, offSet, contracts } = this.state;
        const newOffset = limit + offSet;

        try {
            const response = await api.get(
                `/arts/${id}/contratos?limit=` + limit + "&offset=" + newOffset
            );
            let newContract = response.data.data;
            const contractsConCat = contracts.concat(newContract);
            this.setState({
                contracts: contractsConCat,
                offSet: newOffset,
                hideButton: false
            });
        } catch (erro) {
            this.setState({
                hideButton: true
            });
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    erro,
                    "ERRO-633 Erro ao carregar mais contratos - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
        this.setState({ loading: false });
    };

    addModalClose = e => {
        this.setState({ addModalShow: false });
    };

    ModalYesNoClose = e => {
        this.setState({ showModalText: false });
    }

    updateExportar = async (numeroInicial, numeroFinal) => {
        this.setState({ loadingExport: true, ordemInicial: numeroInicial, ordemFinal: numeroFinal });

        const payload = {
            art_id: this.state.id,
            num_ordem_inicial: parseInt(numeroInicial),
            num_ordem_final: parseInt(numeroFinal)
        }

        window.onbeforeunload = () => 'Seu arquivo está sendo gerado. Tem certeza que deseja sair?';
        try {
            const response = await api.post(`/creasp`, payload);

            this.addModalClose();

            if (response.data.downloadUrl) {
                await downloadFile(response.data.downloadUrl, 'creasp.txt');
            }

            store.addNotification({
                title: "Sucesso!",
                message: "Arquivo gerado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 6000, onScreen: true }
            });

            window.onbeforeunload = null;
            setTimeout(() => {
                window.location.reload();
            }, 1500);
        } catch (error) {
            window.onbeforeunload = null;

            const renewRequired = error?.response?.data?.errors === 'Informe o parâmetro renew=ok';

            if (renewRequired) {
                this.setState({
                    loadingExport: false,
                    addModalShow: false,
                    showModalText: true,
                    textModalYesNo: 'Não há contratos disponíveis no intervalo informado. Isso pode acontecer após reativar uma ART/TRT. Deseja renovar a numeração e tentar exportar novamente?',
                });
                return;
            }

            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-634 Erro ao exportar dados do CREA SP - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 5000, onScreen: true }
            });
            this.setState({ loadingExport: false });
            throw error;
        }
    }

    updateYesNo = async (resposta) => {
        if(resposta == 1){
            try {
                const payload = {
                    art_id: this.state.id,
                    num_ordem_inicial: parseInt(this.state.ordemInicial),
                    num_ordem_final: parseInt(this.state.ordemFinal)
                }
    
                window.onbeforeunload = () => 'Seu arquivo está sendo gerado. Tem certeza que deseja sair?';
                const responseExportar = await api.post(`/creasp?renew=ok`, payload);

                if (responseExportar.data.downloadUrl) {
                    await downloadFile(responseExportar.data.downloadUrl, 'creasp.txt');
                }

                store.addNotification({
                    title: "Sucesso!",
                    message: "Arquivo gerado com sucesso.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: { duration: 6000, onScreen: true }
                });
                this.setState({ showModalText: false, loadingExport: false });
                window.onbeforeunload = null;

                setTimeout(() => {
                    window.location.reload();
                }, 1500);

            } catch (error) {
                this.setState({ showModalText: false });
                this.setState({loadingExport : false});
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(
                        error,
                        "ERRO-635 Erro ao renovar a exportacao do CREA SP - Tente novamente, se o erro persistir acione o suporte."
                    ),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        }else{
            this.setState({ showModalText: false });
            this.setState({loadingExport : false});

        }
    }

    exportCrea = () => {
        let user = JSON.parse(localStorage.getItem(USER));

        if(user.contract_software_id === 6){
            this.setState({ showModalAlert: true })
        } else {
            this.setState({ addModalShow: true });
        }
    }

    updateExport = () => {
        this.setState({ showModalAlert: false });
        this.setState({addModalShow: true});
    }

    loadOrder = async () => {
        const id = this.props.match.params.id;
        this.setState({ id });
        try {
            const response = await api.get(`/relatorios/contratos/ordem/${id}`);
            
            if (response.status === 200) {

                this.setState({ ordemInicial: response.data.ordemInicial });
                this.setState({ ordemFinal: response.data.ordemFinal });
            }
        } catch (erro) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    erro,
                    "ERRO-636 Erro ao buscar ordem inicial e final para exportar dados - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    render() {
        const { contracts, hideButton, loading, loadingExport, addModalShow, showModalText, size_screen } = this.state;

        return (
            <>
                <GenericUpper
                    title="ARTs/TRT"
                    subtitle="Gerencie os contratos da sua ART/TRT"
                ></GenericUpper>
                <ArtsAddContainer>
                    <Container>
                        <TableWithLabelBlackV2
                            columns={[
                                {
                                    key: 'numero_ordem',
                                    label: 'Número da Ordem',
                                    minWidth: '120px',
                                    width: '100%',
                                    maxWidth: '150px',
                                    render: (c) => (
                                        <BodyP color={c.status === 0 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}>
                                            {c.status === 0 ? <strike>{c.numero_ordem}</strike> : c.numero_ordem}
                                        </BodyP>
                                    )
                                },
                                {
                                    key: 'nome_produtor',
                                    label: 'Nome do Produtor',
                                    width: '100%',
                                    minWidth: '200px',
                                    maxWidth: '350px',
                                    maxWidthContent: '350px',
                                    enableHorizontalScroll: true,
                                    render: (c) => (
                                        <BodyM color={c.status === 0 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2} fontWeight={800}>
                                            {c.status === 0 ? <strike>{c.nome_produtor}</strike> : c.nome_produtor}
                                        </BodyM>
                                    )
                                },
                                {
                                    key: 'nome_local_aplicacao',
                                    label: 'Nome da Propriedade',
                                    width: '100%',
                                    minWidth: '250px',
                                    maxWidth: '300px',
                                    maxWidthContent: '300px',
                                    enableHorizontalScroll: true,
                                    render: (c) => (
                                        <TaglineM color={c.status === 0 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2} fontWeight={600}>
                                            {c.status === 0 ? <strike>{c.nome_local_aplicacao}</strike> : c.nome_local_aplicacao}
                                        </TaglineM>
                                    )
                                },
                                {
                                    key: 'data_inicio',
                                    label: 'Data de Início',
                                    minWidth: '130px',
                                    render: (c) => (
                                        <TaglineM color={c.status === 0 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2} fontWeight={600}>
                                            {c.status === 0 ? <strike>{this.formatData(c.data_inicio)}</strike> : this.formatData(c.data_inicio)}
                                        </TaglineM>
                                    )
                                },
                                {
                                    key: 'data_termino',
                                    label: 'Data de Término',
                                    width: '100%',
                                    minWidth: '130px',
                                    maxWidth: '200px',
                                    render: (c) => (
                                        <TaglineM color={c.status === 0 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2} fontWeight={600}>
                                            {c.status === 0 ? <strike>{this.formatData(c.data_termino)}</strike> : this.formatData(c.data_termino)}
                                        </TaglineM>
                                    )
                                }
                            ]}
                            data={contracts}
                            showAll={true}
                            serverSide={true}
                            itemsPerPage={contracts.length || 5}
                            enableDefaultRowNavigation={false}
                            emptyMessage="Nenhum resultado encontrado."
                            onRowClick={(contract) => this.props.history.push(`/editcontract/${contract.id}`)}
                        />

                        <div style={{ width: '100%', display: 'flex', flexDirection: size_screen <= 768 ? 'column' : 'row', justifyContent: 'center', alignItems: 'center', gap: '16px', marginTop: '40px' }}>
                            <Button 
                                width='100%'
                                height='48px'
                                maxWidth='270px'
                                value='ADICIONAR CONTRATOS'
                                outline={true}
                                disabled={false}
                                onClick={() => this.redirect()}
                            />

                            <Button 
                                width='100%'
                                height='48px'
                                maxWidth='270px'
                                value='VER MAIS'
                                outline={loading ? false : true}
                                disabled={false}
                                onClick={() => this.loadMore()}
                                loading={loading}
                            />

                            <Button 
                                width='100%'
                                height='48px'
                                maxWidth='270px'
                                value='EXPORTAR DADOS - CREA SP'
                                outline={true}
                                disabled={false}
                                onClick={() => this.exportCrea()}
                                loading={loadingExport}
                            />
                        </div>

                        <Modal
                            show={this.state.showModalAlert}
                            onHide={false}
                        >
                            <h4 style={{
                                textAlign: 'center'
                            }}>Essa é uma função exclusiva para clientes AgroReceita</h4>

                            <p style={{
                                textAlign: 'center',
                                marginTop: '20px',
                            }}>
                                Para não comprometer o controle de suas receitas agronômicas essa função só pode ser utilizada nos planos Light e Pro. Um arquivo de teste será gerado para que você conheça essa funcionalidade. Entre em contato com nosso suporte e faça o upgrade do seu plano para desbloquear esse recurso
                            </p>

                            <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px' }}>
                                <Button
                                    width='296px'
                                    height='50px'
                                    value='ENTENDI'
                                    outline={false}
                                    disabled={false}
                                    onClick={() => this.updateExport()}
                                    loading={false}
                                />
                            </div>

                        </Modal>

                        {addModalShow == true ? (
                            <ModalExportar
                                show={addModalShow}
                                onHide={this.addModalClose}
                                update={this.updateExportar}
                                title="Exportar dados - CREA SP"
                                artId={this.state.id}
                                ordemInicial={this.state.ordemInicial}
                                ordemFinal={this.state.ordemFinal}
                            ></ModalExportar>
                        ):null}

                        {this.state.textModalYesNo != "" ? (
                            <>
                                {showModalText == true ? (
                                    <ModalYesNo
                                        show={showModalText}
                                        onHide={this.ModalYesNoClose}
                                        title="Exportar dados - CREA SP"
                                        text={this.state.textModalYesNo}
                                        update={this.updateYesNo}
                                    ></ModalYesNo>
                                ):(null)}
                            </>
                        ):(null)}

                    </Container>
                </ArtsAddContainer>
            </>
        );
    }
}
export default withRouter(EditContracts);
